import * as styles from './styles'

export const getTextStyle = (style) => {
  if (style && style.type) {
    if (typeof styles[style.type] === 'function') {
      return styles[style.type](style.params || {})
    }
  }
  return {}
}